import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { useDispatch } from 'react-redux';
import { setMeetingTrack } from "../../redux/actions/leadSourceActions";
import { Dialog, DialogContent, DialogTitle, FormControl, Box, TextField, IconButton, DialogActions, RadioGroup, FormControlLabel, Radio, Button as MuiButton} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { EyeFilled } from '@ant-design/icons';
import { DownloadOutlined } from '@ant-design/icons';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "#1C375D",
        color: 'white'
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
            backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
    tableHeaderCell: {
        backgroundColor: '#f0f8ff',
        fontWeight: 'bold',
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: 'white',
        fontWeight: "500",
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const ProposedMeetingPage = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [dateFilter, setDatefilters] = useState({ startDate: "", endDate: "" });
    const [submitButtonClick, setSubmitButtonClick] = useState(false);
    const [proposeMeetingData, setProposeMeetingData] = useState([]);
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [countData, setCountData] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [proposedMeetingTableCsvData, setProposedMeetingTableCsvData] = useState([]);
    const proposedMeetingTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [lastClickedParams, setLastClickedParams] = useState(null);
    const PROPOSED_MEETING_TABLE_DISABLE_UNTIL_KEY = 'proposedMeetingTable_disableUntil';
    const [isProposedMeetingTableDisabled, setIsProposedMeetingTableDisabled] = useState(false);
    const [proposedMeetingTableTimeLeft, setProposedMeetingTableTimeLeft] = useState(0);
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [commonLocation, setLocation] = useState([])
    const [commonExpCenter, setExpCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
    }
    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        // handleExpData(newvalue)
    }
     const locations = async () => {
            props.setLoading(true);
            try {
                let response = await HttpService.getLocation();
                const matchedUsers = response.data.filter(user => {
                    return userDetails.selectedLocation.includes(user._id);
                });
                setLocation(matchedUsers)
            } catch (error) {
                console.error("Error fetching experience centers:", error);
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
    }
       const expCenters = async () => {
            props.setLoading(true);
            try {
                let response = await HttpService.getExpericenCenters();
                const matchedUsers = response.data.filter(user => {
                    return userDetails.experienceCenterId.includes(user._id);
                });
                setExpCenter(matchedUsers)
            } catch (error) {
                console.error("Error fetching experience centers:", error);
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
        }
    useEffect(() => {
        locations();
        expCenters();
    }, []);
    useEffect(() => {
        getPrposedMeetingData();
    }, [dateFilter,selectedLocation,selectedExperienceCenter]);

    // Timer logic for Proposed Meeting table
    useEffect(() => {
        const disableUntilTimestamp = localStorage.getItem(PROPOSED_MEETING_TABLE_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setIsProposedMeetingTableDisabled(true);
                setProposedMeetingTableTimeLeft(remainingTimeInSeconds);
            } else {
                localStorage.removeItem(PROPOSED_MEETING_TABLE_DISABLE_UNTIL_KEY);
                setIsProposedMeetingTableDisabled(false);
                setProposedMeetingTableTimeLeft(0);
            }
        }

        let timer;
        if (isProposedMeetingTableDisabled && proposedMeetingTableTimeLeft > 0) {
            timer = setInterval(() => {
                setProposedMeetingTableTimeLeft((prevTime) => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        localStorage.removeItem(PROPOSED_MEETING_TABLE_DISABLE_UNTIL_KEY);
                        setIsProposedMeetingTableDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isProposedMeetingTableDisabled, proposedMeetingTableTimeLeft]);

    const getPrposedMeetingData = async () => {
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let locationData = selectedLocation?.map((el) => el._id)
        let obj = {
            startDate: dateFilter.startDate,
            endDate: dateFilter.endDate,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            selectedlocation: locationData ? locationData : "",
        }
        try {
            let res = await HttpService.getProposedMeetingData(obj);
            setProposeMeetingData(res.data)
        }
        catch (err) {
            console.error(err);
            props.setSnackInfo('Something wents wrong', 'error');
        }
    }

    function getHeaderDates(dateFilter, submitButtonClick) {
        let dates = [];
        // Case 1: If both dates are provided → return full range
        if (dateFilter.startDate && dateFilter.endDate) {
            const start = new Date(dateFilter.startDate);
            const end = new Date(dateFilter.endDate);

            while (start <= end) {
                dates.push({
                    raw: start.toISOString().split("T")[0],
                    label: start.toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric"
                    })
                });

                start.setDate(start.getDate() + 1);
            }
            return dates.reverse();
        }

        // Case 2: No startDate/endDate → Show last 7 days including today
        const today = new Date();
        for (let i = 0; i < 7; i++) {
            const d = new Date();
            d.setDate(today.getDate() - i);

            dates.push({
                raw: d.toISOString().split("T")[0],
                label: d.toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "short",
                    year: "numeric"
                })
            });
        }

        return dates.reverse();
    }

    const headerDates = getHeaderDates(dateFilter, submitButtonClick)

    const grouped = proposeMeetingData?.reduce((acc, curr) => {
        const expId = curr.experienceCenter._id;

        if (!acc[expId]) {
            acc[expId] = {
                experienceCenter: curr.experienceCenter,
                totalCount: 0,
                leads: [],
                proposeMeetingDates: []
            };
        }

        acc[expId].totalCount += curr.count;
        acc[expId].leads.push(...curr.leads);
        acc[expId].proposeMeetingDates.push(curr.proposeMeetingDate);

        return acc;
    }, {});

    const result = Object.values(grouped);

    const groupedByExpCenter = result?.map(center => {
        const leadsByDate = center.leads.reduce((acc, lead) => {
            const date = lead.proposeMeetingDate;
            if (!acc[date]) {
                acc[date] = {
                    proposeMeetingDate: date,
                    leads: [],
                    count: 0
                };
            }
            acc[date].leads.push(lead);
            acc[date].count += 1;
            return acc;
        }, {});

        // Convert the map to an array
        return {
            experienceCenter: center.experienceCenter,
            totalCount: center.leads.length,
            proposeMeetingData: Object.values(leadsByDate)  // array of { proposeMeetingDate, leads, count }
        };
    });

    // grand Total amount in table count
    const grandTotalCounts = headerDates.map(hd => {
        let total = 0;

        groupedByExpCenter.forEach(center => {
            const meeting = center.proposeMeetingData.find(
                pd => pd.proposeMeetingDate === hd.label
            );
            total += meeting ? meeting.count : 0;
        });

        return {
            date: hd.label,
            count: total,
        };
    });

    // console.log("groupedByExpCenter",groupedByExpCenter);

    // Function to generate CSV data for proposed meeting table
    const generateProposedMeetingTableCsvData = () => {
        try {
            if (!groupedByExpCenter || groupedByExpCenter.length === 0 || !headerDates || headerDates.length === 0) {
                return [];
            }

            const csvRows = [];

            // Build header row - match table structure exactly
            const headerRow = {
                "Propose Meeting Date": ""
            };

            // Add date columns
            headerDates.forEach((dateEl) => {
                if (dateEl.label) {
                    headerRow[dateEl.label] = "";
                }
            });
            headerRow["Total"] = "";
            csvRows.push(headerRow);

            // Add experience center rows
            groupedByExpCenter.forEach((expCenterEl) => {
                const row = {
                    "Propose Meeting Date": expCenterEl.experienceCenter?.code || ""
                };

                // Add counts for each date
                headerDates.forEach((dateEl) => {
                    const meetingData = expCenterEl.proposeMeetingData?.find(
                        (pd) => pd.proposeMeetingDate === dateEl.label
                    );
                    row[dateEl.label] = meetingData?.count || 0;
                });

                // Add total count for this experience center
                row["Total"] = expCenterEl.totalCount || 0;
                csvRows.push(row);
            });

            // Add Grand Total row
            const grandTotalRow = {
                "Propose Meeting Date": "Grand Total"
            };

            // Add grand totals for each date
            grandTotalCounts.forEach((grandTotalEl) => {
                grandTotalRow[grandTotalEl.date] = grandTotalEl.count || 0;
            });

            // Add overall grand total
            const overallGrandTotal = groupedByExpCenter.reduce((sum, item) => sum + Number(item.totalCount || 0), 0);
            grandTotalRow["Total"] = overallGrandTotal;
            csvRows.push(grandTotalRow);

            return csvRows;
        } catch (error) {
            console.error("Error generating proposed meeting table CSV:", error);
            return [];
        }
    };

    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "currentStage", label: "Current Stage" },
        { key: "meetingType", label: "Propose Meeting Type" },
        { key: "meetingDate", label: "Propose Meeting Date" },
        { key: "participant", label: "Meeting Participant" },
        { key: "salesExecutive", label: "Sales Executive" },
        { key: "asm", label: "ASM" },
    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            setLoading(true);
             for (let i = 0; i < countData.length; i++) {
                const data = countData[i];
                let obj = {
                     serialNo: i + 1,
                     projectCode: data.erpProjectNo ? data.erpProjectNo : 'NA',
                     leadNumber: data?.lead_no ? data?.lead_no : "NA",
                     clientName: data?.customerName ? data?.customerName : "NA",
                     expCtrName: data?.experienceCenterName ? data?.experienceCenterName : 'NA',
                     currentStage: data.currentStage ? data.currentStage : 'NA',
                     meetingType: data.proposeMeetingType ? data.proposeMeetingType : 'NA',
                     meetingDate: data.proposeMeetingDate ? moment(data.proposeMeetingDate).format('DD-MM-YYYY') : "NA",
                     participant: data.meetingParticipant ? data.meetingParticipant : 'NA',
                     salesExecutive: data.salesUser ? data.salesUser : "NA",
                     asm: data?.salesAssistantManager ? data?.salesAssistantManager : "NA"
                }
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    //  handle date filter
    const handleDateFilter = (e) => {
        const { name, value } = e.target
        setSubmitButtonClick(false);
        setDatefilters({ ...dateFilter, [name]: value })
    }

    // handle search lead
    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }
    const handleSearch = async (value) => {
        getPrposedMeetingData();
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    // clear date filter
    const clearDateFilter = () => {
        setSearchInput("");
        setSelectedSearchType("");
        setDatefilters({ startDate: "", endDate: "" });
        // getPrposedMeetingData();
    }

    const handleSubmitButton = () => {
        setSubmitButtonClick(true);
        getPrposedMeetingData();
    }

    const handleCountData = (expCenterCode, header, type) => {
        try {
            // Store parameters for refresh functionality
            setLastClickedParams({ expCenterCode, header, type });
            setIsModelOpen(true);
            if (type === 'count') {
                const data = proposeMeetingData.find(
                    (item) =>
                        item.proposeMeetingDate === header &&
                        item.experienceCenter?.code === expCenterCode
                );
                if (data) {
                    setCountData(data.leads);
                }
            } else if (type === 'total') {
                const data = proposeMeetingData.filter(
                    (item) =>
                        item.experienceCenter?.code === expCenterCode
                );
                if (data) {
                    const allLeads = data.flatMap(item => item.leads);
                    setCountData(allLeads);
                }
            } else if (type === 'grandTotal') {
                 const data = proposeMeetingData.filter(
                    (item) =>
                        item.proposeMeetingDate === header
                );
                if (data) {
                    const allLeads = data.flatMap(item => item.leads);
                    setCountData(allLeads);
                }
            } else if (type === 'overTotal') {
                const allLeads = proposeMeetingData.flatMap(item => item.leads);
                setCountData(allLeads);
            }
        }
        catch (err) {
            console.error(err);
            props.setSnackInfo('Something went wrong', err);
        }
    }

    const formatProposedMeetingTableTimeLeft = () => {
        const minutes = Math.floor(proposedMeetingTableTimeLeft / 60);
        const seconds = proposedMeetingTableTimeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const handleRefreshMainTable = async () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(PROPOSED_MEETING_TABLE_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsProposedMeetingTableDisabled(true);
        setProposedMeetingTableTimeLeft(240); // 4 minutes in seconds

        props.setLoading(true);
        try {
            await getPrposedMeetingData();
            props.setSnackInfo('Table refreshed successfully', "success");
        } catch (error) {
            props.setSnackInfo('Error refreshing table', "error");
            console.error('Error refreshing table:', error);
        } finally {
            props.setLoading(false);
        }
    };

    const handleRefreshModalTable = async () => {
        props.setLoading(true);
        try {
            await getPrposedMeetingData();
            // Re-populate modal data using stored parameters
            if (lastClickedParams) {
                handleCountData(lastClickedParams.expCenterCode, lastClickedParams.header, lastClickedParams.type);
            }
            props.setSnackInfo('Modal table refreshed successfully', "success");
        } catch (error) {
            props.setSnackInfo('Error refreshing modal table', "error");
            console.error('Error refreshing modal table:', error);
        } finally {
            props.setLoading(false);
        }
    };

    return (
        <div className="App">
            <div>
                <div>
                    <Paper className={classes.paper}>
                        <Grid container spacing={2} justifyContent="center" alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <FormControl style={{ width: '100%' }}>
                                    <Autocomplete
                                        multiple
                                        value={selectedLocation}
                                        onChange={handleMultipleLocationData}
                                        options={commonLocation}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Location"
                                            variant="outlined"
                                        />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl style={{ width: '100%'}}>
                                    <Autocomplete
                                        multiple
                                        value={selectedExperienceCenter}
                                        onChange={handleMultipleExpData}
                                        options={commonExpCenter}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                            <TextField
                                            {...params}
                                            label="Select Exp-Center"
                                            variant="outlined"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>                                 
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    id="startDate"
                                    name="startDate"
                                    label="Propose Meeting From Date"
                                    type="date"
                                    variant="outlined"
                                    value={dateFilter.startDate}
                                    onChange={handleDateFilter}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    id="endDate"
                                    name="endDate"
                                    label="Propose Meeting End Date"
                                    type="date"
                                    variant="outlined"
                                    value={dateFilter.endDate}
                                    onChange={handleDateFilter}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Button variant="contained" color="primary" onClick={handleSubmitButton} style={{ backgroundColor: "#F50057", color: "#fff", padding: "0.4rem 2rem 2rem 2rem" }} className={classes.submitButton} >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>

                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                            {/* Search Type Dropdown */}
                            <TextField
                                select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedSearchType}
                                label="Search Type"
                                name="searchType"
                                onChange={(e) => handleSearchType(e.target.value)}
                                variant="outlined"
                                style={{ width: '30%', marginRight: '2%' }}
                                size="small"
                            >
                                {searchTypes && searchTypes?.map((el, index) => (
                                    <MenuItem key={index} value={el}>{el}</MenuItem>
                                ))}
                            </TextField>

                            {/* Search Input */}
                            <TextField
                                label="Enter the input"
                                name="searched"
                                size="small"
                                value={searchInput}
                                onChange={(e) => { setSearchInput(e.target.value) }}
                                onKeyDown={handleKeyDown}
                                variant="outlined"
                                style={{ width: '80%' }}
                            />

                            {/* Search Button */}
                            <Button
                                disabled={!selectedSearchType || !searchInput}
                                variant="contained"
                                color="primary"
                                size="medium"
                                style={{ alignSelf: "center", marginLeft: 20 }}
                                className={classes.leadSearchButton}
                                onClick={() => handleSearch(searchInput.toUpperCase())}
                            >
                                Search
                            </Button>

                            {/* Clear Filter Button */}
                            <Button
                                variant="contained"
                                color="secondary"
                                size="medium"
                                style={{ marginLeft: 10 }}
                                className={classes.leadClearButton}
                                onClick={clearDateFilter}
                            >
                                Clear Filter
                            </Button>
                        </div>
                    </Paper>
                </div>
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginTop: '30px' }}>
                        <MuiButton
                            onClick={handleRefreshMainTable}
                            variant="contained"
                            disabled={isProposedMeetingTableDisabled}
                            style={{ 
                                backgroundColor: isProposedMeetingTableDisabled ? "#cccccc" : "#F47E46", 
                                color: "#FFFFFF",
                                padding: "8px 16px"
                            }}
                        >
                            {isProposedMeetingTableDisabled 
                                ? `Wait (${formatProposedMeetingTableTimeLeft()})` 
                                : "Fetch New Data"}
                        </MuiButton>
                        <CSVLink
                            data={proposedMeetingTableCsvData}
                            filename={`Proposed_Meeting_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                            ref={proposedMeetingTableCsvButtonRef}
                            style={{ textDecoration: 'none', display: 'none' }}
                        />
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            style={{
                                backgroundColor: "#355025",
                                color: "#FFF2EB",
                                padding: "0.4rem 2rem",
                                border: "none"
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                
                                const csvData = generateProposedMeetingTableCsvData();

                                // Set the data and trigger download
                                if (csvData.length > 0) {
                                    setProposedMeetingTableCsvData(csvData);
                                    setTimeout(() => {
                                        setTriggerDownload(true);
                                    }, 100);
                                } else {
                                    props?.setSnackInfo("No data available to export", "warning");
                                }
                            }}
                        >
                            Download CSV
                        </Button>
                    </div>
                    <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                        <Table>
                            {/* table head */}
                            <TableHead style={{ position: 'sticky', background: 'white' }}>
                                <StyledTableRow>
                                    <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold' }}> Propose Meeting Date </StyledTableCell>
                                    {headerDates?.map((el, index) => (
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            key={index}
                                            style={{
                                                fontSize: '13px',
                                                fontWeight: 'bolder',
                                                textAlign: 'center',
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 1,
                                            }}
                                        >
                                            {el?.label ? el?.label : '-'}
                                        </StyledTableCell>
                                    ))}
                                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", fontWeight: 'bold', background: '#1C375D', color: 'white' }}>
                                        Total
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>

                            {/* Table Body */}
                            <TableBody style={{ position: 'sticky', top: 0, background: 'white' }}>
                                {groupedByExpCenter?.map((el, index) => (
                                    <StyledTableRow>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            key={index}
                                            style={{
                                                fontWeight: 'bolder',
                                                textAlign: 'center',
                                                position: 'sticky',
                                                top: 0, 
                                                left: 0,
                                                 zIndex: 9,
                                            }}
                                        >
                                            <span style={{ cursor: "pointer" }}>
                                                {el?.experienceCenter?.code}
                                            </span>
                                        </StyledTableCell>
                                        {headerDates?.map((data, idx) => {
                                            const meetingData = el?.proposeMeetingData?.find(
                                                (pd) => pd?.proposeMeetingDate === data?.label
                                            );
                                            return (
                                                <StyledTableCell
                                                    component="th"
                                                    key={idx}
                                                    onClick={()=>handleCountData(el.experienceCenter.code, data?.label, 'count')}
                                                    style={{
                                                        textAlign: 'center',
                                                        position: 'sticky',
                                                        cursor: 'pointer',
                                                        textDecoration: 'underline',
                                                    }}
                                                >
                                                    {meetingData ? meetingData?.count : 0}
                                                </StyledTableCell>
                                            );
                                        })}
                                        <StyledTableCell
                                            onClick={()=>handleCountData(el.experienceCenter.code, 'total', 'total')}
                                            className={classes.bordercolors}
                                            key={index}
                                            style={{
                                                fontWeight: 'bolder',
                                                textAlign: 'center',
                                                position: 'sticky',
                                                cursor: 'pointer',
                                                textDecoration: 'underline'
                                            }}
                                        >
                                            <span style={{ cursor: "pointer" }}>
                                                {el?.totalCount}
                                            </span>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                                <StyledTableRow>
                                    <StyledTableCell
                                        className={classes.bordercolors}
                                        style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold' }}
                                        rowSpan={1}
                                    >
                                        Grand Total
                                    </StyledTableCell>
                                    {grandTotalCounts?.map((el, index) => (
                                        <StyledTableCell
                                            key={index}
                                            className={classes.bordercolors}
                                            onClick={()=>handleCountData('grandTotal', el.date, 'grandTotal' )}
                                            style={{
                                                textAlign: "center",
                                                cursor: "pointer",
                                                fontWeight: 'bolder',
                                                background: "#1C375D",
                                                color: 'white',
                                                textDecoration: "underline"
                                            }}
                                        >
                                            {el?.count}
                                        </StyledTableCell>
                                    ))}
                                    <StyledTableCell
                                        className={classes.bordercolors}
                                        style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold', cursor: 'pointer', textDecoration: 'underline' }}
                                        rowSpan={1}
                                        onClick={()=>handleCountData('overAll', 'overTotal', 'overTotal')}
                                    >
                                        {groupedByExpCenter?.reduce((sum, item) => sum + Number(item.totalCount), 0)}
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <br />
            </div>
            {/* Model for total count */}
            <Modal
                title='Propose Meeting Data'
                centered
                visible={isModelOpen}
                onCancel={() => setIsModelOpen(false)}
                width={1000}
                maskClosable={true}
                footer={null}
                zIndex={2000}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename='proposeMeetingData.csv'
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(countData)}
                        style={{ backgroundColor: "#355025", color: "#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 500 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Experience Center</StyledTableCell>
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                    <StyledTableCell>Propose Meeting Type</StyledTableCell>
                                    <StyledTableCell>Propose Meeting Date</StyledTableCell>
                                    <StyledTableCell>Meeting Participant</StyledTableCell>
                                    <StyledTableCell>Sales Executive</StyledTableCell>
                                    <StyledTableCell>ASM</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                        {countData && (
                            <TableBody>
                                {countData?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}> 
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {i + 1}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.erpProjectNo ? (
                                                    <Link
                                                        to={`/project-logs/${data?.leadId}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: "#000", textDecoration: "underline" }}
                                                    >
                                                        {data?.erpProjectNo ? data?.erpProjectNo : "NA"}
                                                    </Link>
                                                ) : (
                                                    "NA"
                                                )}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.lead_no || data?.lead_no ? (
                                                    <Link
                                                        to={`/project-logs/${data?.leadId}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: "#000", textDecoration: "underline" }}
                                                    >
                                                        {data?.lead_no ? data?.lead_no : 'NA'}
                                                    </Link>
                                                ) : (
                                                    "NA"
                                                )}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.customerName ? data?.customerName : "NA"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.experienceCenterName ? data?.experienceCenterName : "NA"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.currentStage ? data?.currentStage : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.proposeMeetingType ? data?.proposeMeetingType : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.proposeMeetingDate ? moment(data?.proposeMeetingDate).format("DD-MM-YYYY") : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.meetingParticipant ? data?.meetingParticipant : '-' }
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.salesUser ? data?.salesUser : "NA"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                                {data?.salesAssistantManager ? data?.salesAssistantManager : "NA"}
                                            </StyledTableCell>
                                         </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                            )}
                        </Table>
                    </TableContainer>
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(ProposedMeetingPage);